
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kKeZ6", function(module, exports) {

$parcel$export(module.exports, "ProfileCard", () => $65eeb7d31cebb7a6$export$bed540ccfa8743c4);
$parcel$export(module.exports, "default", () => $65eeb7d31cebb7a6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $iXVV6 = parcelRequire("iXVV6");

var $5y0F0 = parcelRequire("5y0F0");

var $koVbs = parcelRequire("koVbs");

var $90yGq = parcelRequire("90yGq");


var $f5xXn = parcelRequire("f5xXn");

var $7I2zi = parcelRequire("7I2zi");

var $3Mgim = parcelRequire("3Mgim");
const $65eeb7d31cebb7a6$export$bed540ccfa8743c4 = ({ externalProfileClient: externalProfileClient, accountId: accountId, actions: actions, analyticsData: analyticsData, children: children, position: position, testId: testId, trigger: trigger, prepopulatedData: prepopulatedData, ariaHideProfileTrigger: ariaHideProfileTrigger, isChildComment: isChildComment = false, shouldTruncate: shouldTruncate = false })=>{
    const intl = (0, $koVbs.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const currentUserAccountId = (0, $90yGq.useAccountId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: (0, $e6a2e0952e4731b8$export$81319ffa9c0d18d7),
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5xXn.ProfileCardWrapper), {
        externalProfileClient: externalProfileClient
    }, currentUserAccountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Mgim.ProfileCardView), {
            accountId: accountId,
            actions: (0, $7I2zi.getSpaActions)(accountId, intl, push, actions),
            position: position,
            onProfileClick: (profileAccountId)=>push(`/jira/people/${profileAccountId}`),
            addFlag: showFlag,
            dismissFlag: dismissFlag,
            testId: testId,
            trigger: trigger,
            prepopulatedData: prepopulatedData,
            ariaHideProfileTrigger: ariaHideProfileTrigger,
            isChildComment: isChildComment,
            shouldTruncate: shouldTruncate
        }, children)) : children));
};
var $65eeb7d31cebb7a6$export$2e2bcd8739ae039 = $65eeb7d31cebb7a6$export$bed540ccfa8743c4;

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("f5xXn", function(module, exports) {

$parcel$export(module.exports, "ProfileCardWrapper", () => $05053b3a38034fd2$export$59abd6feb7dc8540);

var $5uXOq = parcelRequire("5uXOq");

var $koeKL = parcelRequire("koeKL");

var $90yGq = parcelRequire("90yGq");

var $4oO9d = parcelRequire("4oO9d");

var $gLmUz = parcelRequire("gLmUz");

var $cSD7y = parcelRequire("cSD7y");

var $9l5Jv = parcelRequire("9l5Jv");
const $05053b3a38034fd2$var$ProfileCardWrapperWithoutOrgId = ({ externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const fabricPfDirUrl = (0, $gLmUz.useFabricProfileDirectoryUrl)();
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9l5Jv.ProfileClientContainer), {
        fabricPfDirUrl: fabricPfDirUrl,
        profileClient: externalProfileClient || null,
        onLoadError: onLoadError,
        cloudId: cloudId,
        // Only use the global store when no external client is provided
        isGlobal: !externalProfileClient
    }, children);
    // When there is no tenantContext, this will cause the child
    // component of <ProfileCard> to render without being wrapped by
    // a profile card and it will do nothing on hover
    return children;
};
const $05053b3a38034fd2$var$ProfileCardWrapperWithOrgId = ({ externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const fabricPfDirUrl = (0, $gLmUz.useFabricProfileDirectoryUrl)();
    const orgId = (0, $4oO9d.useOrgId)();
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9l5Jv.ProfileClientContainer), {
        fabricPfDirUrl: fabricPfDirUrl,
        profileClient: externalProfileClient || null,
        onLoadError: onLoadError,
        cloudId: cloudId,
        // Only use the global store when no external client is provided
        isGlobal: !externalProfileClient,
        orgId: orgId
    }, children);
    // When there is no tenantContext, this will cause the child
    // component of <ProfileCard> to render without being wrapped by
    // a profile card and it will do nothing on hover
    return children;
};
const $05053b3a38034fd2$export$59abd6feb7dc8540 = (0, $cSD7y.componentWithFG)('issue_view_prevent_unnecessary_orgid_query', $05053b3a38034fd2$var$ProfileCardWrapperWithOrgId, $05053b3a38034fd2$var$ProfileCardWrapperWithoutOrgId);

});
parcelRegister("4oO9d", function(module, exports) {

$parcel$export(module.exports, "useOrgId", () => $554c0ec604398cd6$export$52a03a3207af3687);

var $9OXo1 = parcelRequire("9OXo1");
const $554c0ec604398cd6$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});

parcelRegister("gLmUz", function(module, exports) {

$parcel$export(module.exports, "useFabricProfileDirectoryUrl", () => $53e785fb2e37b84f$export$cb9379d435214a54);

var $9OXo1 = parcelRequire("9OXo1");
const $53e785fb2e37b84f$export$cb9379d435214a54 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.fabricPfDirUrl || '';
};

});

parcelRegister("9l5Jv", function(module, exports) {

$parcel$export(module.exports, "createUserProfileCardClient", () => $85b7b963f4e84597$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientContainer", () => $85b7b963f4e84597$export$d816ba2709570028);
$parcel$export(module.exports, "useProfileClient", () => $85b7b963f4e84597$export$d43dc22a8337ee9f);

var $blw2B = parcelRequire("blw2B");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $58UyI = parcelRequire("58UyI");
const $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $85b7b963f4e84597$var$createUserProfileCardClientWithoutOrgId = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, _orgId)=>{
    const userClient = new (0, $58UyI.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $blw2B.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId
    }, {
        userClient: userClient
    });
};
const $85b7b963f4e84597$var$createUserProfileCardClientWithOrgId = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, orgId)=>{
    const userClient = new (0, $58UyI.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $blw2B.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId,
        orgId: orgId
    }, {
        userClient: userClient
    });
};
const $85b7b963f4e84597$export$c4393c51e6d104c3 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('issue_view_prevent_unnecessary_orgid_query'), $85b7b963f4e84597$var$createUserProfileCardClientWithOrgId, $85b7b963f4e84597$var$createUserProfileCardClientWithoutOrgId);
const $85b7b963f4e84597$export$e324594224ef24da = {
    bootstrap: ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, profileClient: profileClient, onLoadError: onLoadError, cloudId: cloudId, orgId: orgId })=>{
            if ((0, $4R6GH.fg)('issue_view_prevent_unnecessary_orgid_query')) {
                const finalProfileClient = profileClient || $85b7b963f4e84597$var$createUserProfileCardClientWithOrgId(fabricPfDirUrl ?? '', onLoadError, $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL, cloudId, orgId);
                setState({
                    profileClient: finalProfileClient
                });
            } else {
                const finalProfileClient = profileClient || $85b7b963f4e84597$var$createUserProfileCardClientWithoutOrgId(fabricPfDirUrl ?? '', onLoadError, $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL, cloudId);
                setState({
                    profileClient: finalProfileClient
                });
            }
        }
};
const $85b7b963f4e84597$export$d816ba2709570028 = (0, $gg7kZ.createContainer)({
    displayName: 'ProfileClientContainer'
});
const $85b7b963f4e84597$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $85b7b963f4e84597$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'ProfileClientStore',
    initialState: $85b7b963f4e84597$export$d4c72bab9d6cc13a,
    actions: $85b7b963f4e84597$export$e324594224ef24da,
    containedBy: $85b7b963f4e84597$export$d816ba2709570028,
    handlers: {
        onInit: ()=>({ dispatch: dispatch })=>dispatch($85b7b963f4e84597$export$e324594224ef24da.bootstrap())
    }
});
const $85b7b963f4e84597$export$d43dc22a8337ee9f = (0, $3sQ5x.createStateHook)($85b7b963f4e84597$export$6f57813fe9f31bf9);

});
parcelRegister("blw2B", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b628efa3a075dd4$export$2e2bcd8739ae039);


var $bp5g1 = parcelRequire("bp5g1");


var $dFLsP = parcelRequire("dFLsP");
var $2b628efa3a075dd4$export$2e2bcd8739ae039 = (0, $bp5g1.default);

});
parcelRegister("bp5g1", function(module, exports) {

$parcel$export(module.exports, "default", () => $35fb800f6bdcf84a$export$2e2bcd8739ae039);

var $kTK0a = parcelRequire("kTK0a");
var $aIZdc = parcelRequire("aIZdc");

var $4zh20 = parcelRequire("4zh20");

var $4mT2s = parcelRequire("4mT2s");

var $fjEAi = parcelRequire("fjEAi");

var $dFLsP = parcelRequire("dFLsP");
const $35fb800f6bdcf84a$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $35fb800f6bdcf84a$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$35fb800f6bdcf84a$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $35fb800f6bdcf84a$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $dFLsP.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $fjEAi.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $4zh20.default)(withDefaultConfig);
        this.tcClient = $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $kTK0a.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $kTK0a.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $aIZdc.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $4mT2s.default)({
        ...config
    }) : undefined;
}
var $35fb800f6bdcf84a$export$2e2bcd8739ae039 = $35fb800f6bdcf84a$var$ProfileCardClient;

});
parcelRegister("4zh20", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b1bd6752a000ab$export$2e2bcd8739ae039);

var $ivXTE = parcelRequire("ivXTE");

var $6TKEY = parcelRequire("6TKEY");

var $cZg4V = parcelRequire("cZg4V");

var $f3Zb8 = parcelRequire("f3Zb8");
const $23b1bd6752a000ab$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $23b1bd6752a000ab$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`/gateway/api/assist/agents/v1/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`/gateway/api/assist/agents/v1/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("ivXTE", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $533bc31bb6af10e0$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $533bc31bb6af10e0$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $533bc31bb6af10e0$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $533bc31bb6af10e0$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $533bc31bb6af10e0$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $533bc31bb6af10e0$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $533bc31bb6af10e0$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $533bc31bb6af10e0$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $533bc31bb6af10e0$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $533bc31bb6af10e0$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $533bc31bb6af10e0$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $533bc31bb6af10e0$export$a9f8c9f412cf5664);

var $6TKEY = parcelRequire("6TKEY");
/** Below lines are copied from teams common analytics */ const $533bc31bb6af10e0$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $533bc31bb6af10e0$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $533bc31bb6af10e0$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $533bc31bb6af10e0$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($533bc31bb6af10e0$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $533bc31bb6af10e0$var$TEAM_SUBJECT = 'teamProfileCard';
const $533bc31bb6af10e0$var$USER_SUBJECT = 'profilecard';
const $533bc31bb6af10e0$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $533bc31bb6af10e0$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $6TKEY.getPageTime)())
        }
    });
const $533bc31bb6af10e0$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $533bc31bb6af10e0$var$USER_SUBJECT;
        case 'team':
            return $533bc31bb6af10e0$var$TEAM_SUBJECT;
        case 'agent':
            return $533bc31bb6af10e0$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $533bc31bb6af10e0$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $533bc31bb6af10e0$var$createEvent('ui', 'triggered', $533bc31bb6af10e0$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $533bc31bb6af10e0$export$c9b0e37b229a297b = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$TEAM_SUBJECT, 'request', attributes);
const $533bc31bb6af10e0$export$12dae48763368ac9 = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$USER_SUBJECT, 'request', attributes);
const $533bc31bb6af10e0$export$41816a317479160b = (type, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'rendered', $533bc31bb6af10e0$var$getActionSubject(type), actionSubjectId, attributes);
const $533bc31bb6af10e0$export$fdcd134fbeb1f921 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'action', attributes);
const $533bc31bb6af10e0$export$93260987012593be = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$USER_SUBJECT, 'reportingLines', attributes);
const $533bc31bb6af10e0$export$79befd155063a6a7 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'moreActions', attributes);
const $533bc31bb6af10e0$export$2703289b35687fde = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'avatar', attributes);
const $533bc31bb6af10e0$export$b4411a7661cf2d3f = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $533bc31bb6af10e0$export$c86679da702d560e = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $533bc31bb6af10e0$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("6TKEY", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $83ec369559ddc36d$export$e9faea7c41053334);
const $83ec369559ddc36d$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $83ec369559ddc36d$var$performanceAvailable = $83ec369559ddc36d$var$isPerformanceAvailable();
const $83ec369559ddc36d$var$initialPageTime = Date.now();
const $83ec369559ddc36d$export$e9faea7c41053334 = ()=>{
    if ($83ec369559ddc36d$var$performanceAvailable) return performance.now();
    return Date.now() - $83ec369559ddc36d$var$initialPageTime;
};

});


parcelRegister("cZg4V", function(module, exports) {

$parcel$export(module.exports, "default", () => $e76084040147eae1$export$2e2bcd8739ae039);

var $iwKVT = parcelRequire("iwKVT");
class $e76084040147eae1$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $iwKVT.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});

parcelRegister("f3Zb8", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $b5fa858d1f1072ea$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $b5fa858d1f1072ea$export$d9ad65d422ee3f8c);

var $fcA5f = parcelRequire("fcA5f");
const $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $b5fa858d1f1072ea$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return !!error && $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $fcA5f.AGGError)) return !!error.errorType && $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $fcA5f.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $fcA5f.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $fcA5f.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $fcA5f.DirectoryGraphQLErrors) || causeError instanceof (0, $fcA5f.AGGErrors)) return $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $b5fa858d1f1072ea$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $fcA5f.DirectoryGraphQLErrors)(errors, traceId);
};
const $b5fa858d1f1072ea$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $fcA5f.AGGErrors)(errors, traceId);
};

});
parcelRegister("fcA5f", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $7db90b14dd6e48a6$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $7db90b14dd6e48a6$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $7db90b14dd6e48a6$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $7db90b14dd6e48a6$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $7db90b14dd6e48a6$export$60d8267243755b9c);
class $7db90b14dd6e48a6$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $7db90b14dd6e48a6$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $7db90b14dd6e48a6$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $7db90b14dd6e48a6$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $7db90b14dd6e48a6$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("4mT2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8d68ade6ab7f448$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cZg4V = parcelRequire("cZg4V");

var $a6hGK = parcelRequire("a6hGK");

var $hnIbm = parcelRequire("hnIbm");
const $b8d68ade6ab7f448$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $b8d68ade6ab7f448$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $b8d68ade6ab7f448$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $b8d68ade6ab7f448$var$orgIdPromiseCache = new Map();
const $b8d68ade6ab7f448$var$workspaceExistsWithTypePromiseCache = new Map();
class $b8d68ade6ab7f448$var$TeamCentralCardClient extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $b8d68ade6ab7f448$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $b8d68ade6ab7f448$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $b8d68ade6ab7f448$export$1862ef0c3880ca8d(userId);
        const response = await (0, $hnIbm.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $VSDnB.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $b8d68ade6ab7f448$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $b8d68ade6ab7f448$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $VSDnB.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $b8d68ade6ab7f448$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return Promise.resolve(workspaceType);
            }
        } catch (err) {
            return Promise.resolve(undefined);
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $b8d68ade6ab7f448$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $a6hGK.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
        $b8d68ade6ab7f448$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $b8d68ade6ab7f448$export$2e2bcd8739ae039 = $b8d68ade6ab7f448$var$TeamCentralCardClient;

});
parcelRegister("a6hGK", function(module, exports) {

$parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", () => $9b806d5a2251e5d5$export$d38a536fd806c68f);

var $hnIbm = parcelRequire("hnIbm");
const $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $9b806d5a2251e5d5$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $9b806d5a2251e5d5$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $hnIbm.AGGQuery)(url, query, $9b806d5a2251e5d5$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}

});
parcelRegister("hnIbm", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $7fa677c30fceb004$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $7fa677c30fceb004$export$a14afb5f82fe705);

var $fcA5f = parcelRequire("fcA5f");

var $f3Zb8 = parcelRequire("f3Zb8");
const $7fa677c30fceb004$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $7fa677c30fceb004$var$id = (headers)=>headers;
async function $7fa677c30fceb004$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
    return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleDirectoryGraphQLErrors));
}
async function $7fa677c30fceb004$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
    return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleAGGErrors));
}
async function $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id, handleErrors) {
    const headers = processHeaders($7fa677c30fceb004$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $fcA5f.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});



parcelRegister("fjEAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb2f761841b49fec$export$2e2bcd8739ae039);

var $ivXTE = parcelRequire("ivXTE");

var $6TKEY = parcelRequire("6TKEY");

var $cZg4V = parcelRequire("cZg4V");

var $f3Zb8 = parcelRequire("f3Zb8");

var $5Uw6l = parcelRequire("5Uw6l");
class $fb2f761841b49fec$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $5Uw6l.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('succeeded', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('failed', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("5Uw6l", function(module, exports) {

$parcel$export(module.exports, "extractIdFromAri", () => $c02eddc07333bc73$export$5816a09dbb711691);
$parcel$export(module.exports, "getTeamFromAGG", () => $c02eddc07333bc73$export$26a8aad0c7182dd6);

var $VSDnB = parcelRequire("VSDnB");

var $hnIbm = parcelRequire("hnIbm");
const $c02eddc07333bc73$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $c02eddc07333bc73$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $c02eddc07333bc73$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $c02eddc07333bc73$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($c02eddc07333bc73$var$ARI_PREFIX) ? teamIdOrTeamAri : $c02eddc07333bc73$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $c02eddc07333bc73$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $c02eddc07333bc73$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $c02eddc07333bc73$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $c02eddc07333bc73$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$c02eddc07333bc73$var$TEAM_FRAGMENT}
    }
  }
}`;
const $c02eddc07333bc73$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $c02eddc07333bc73$export$4968f4e0119a5d9c,
        variables: {
            teamId: (0, $VSDnB.fg)('team_id_to_ari_safe') ? $c02eddc07333bc73$export$7878e28c136af76(teamId) : $c02eddc07333bc73$export$681597d03c8a0fd2(teamId),
            siteId: siteId || 'None'
        }
    });
const $c02eddc07333bc73$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $c02eddc07333bc73$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $c02eddc07333bc73$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $hnIbm.AGGQuery)(url, query, $c02eddc07333bc73$export$1229c72526c01df2);
    return $c02eddc07333bc73$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("dFLsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $eafd789fd4bdf3ff$export$2e2bcd8739ae039);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");

var $VSDnB = parcelRequire("VSDnB");

var $ivXTE = parcelRequire("ivXTE");

var $2qnn4 = parcelRequire("2qnn4");

var $6TKEY = parcelRequire("6TKEY");

var $cZg4V = parcelRequire("cZg4V");

var $f3Zb8 = parcelRequire("f3Zb8");

var $hnIbm = parcelRequire("hnIbm");
const $eafd789fd4bdf3ff$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $eafd789fd4bdf3ff$var$aggUserQuery = (0, $5cllN.default)`
	query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`;
const $eafd789fd4bdf3ff$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $eafd789fd4bdf3ff$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $VSDnB.fg)('platform_agg_user_query_doc_change') ? (0, $1c8Um.print)($eafd789fd4bdf3ff$var$aggUserQuery) : $eafd789fd4bdf3ff$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $eafd789fd4bdf3ff$var$queryAGGUser = async (url, userId)=>{
    const query = $eafd789fd4bdf3ff$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $hnIbm.AGGQuery)(url, query);
    return user;
};
class $eafd789fd4bdf3ff$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $eafd789fd4bdf3ff$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        if (user.zoneinfo) {
            if ((0, $2qnn4.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $2qnn4.localTime)(user.zoneinfo, 'h:mmbbb') || undefined;
            else timestring = (0, $2qnn4.localTime)(user.zoneinfo, 'eee h:mmbbb') || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('succeeded', {
                    duration: (0, $6TKEY.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('failed', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("2qnn4", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $de778707e3f7ab0e$export$f0dfd716e7b023cd);
parcelRequire("7UQ5i");
var $9uIbX = parcelRequire("9uIbX");
const $de778707e3f7ab0e$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $9uIbX.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("7UQ5i", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("9uIbX")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $9uIbX = parcelRequire("9uIbX");





});
parcelRegister("9uIbX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e9932008c468ee4$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $cmObS = parcelRequire("cmObS");

var $2b4cP = parcelRequire("2b4cP");
function $6e9932008c468ee4$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $cmObS.default)((0, $2b4cP.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("cmObS", function(module, exports) {

$parcel$export(module.exports, "default", () => $900e78e49c474eed$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $920RE = parcelRequire("920RE");

var $2q3K8 = parcelRequire("2q3K8");
var $900e78e49c474eed$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $900e78e49c474eed$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($900e78e49c474eed$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $2q3K8.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $920RE.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("920RE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6934f899b8aefb37$export$2e2bcd8739ae039);

var $927cR = parcelRequire("927cR");

var $6JaJ1 = parcelRequire("6JaJ1");
var $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE = 60000;
var $6934f899b8aefb37$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $6934f899b8aefb37$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $927cR.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $927cR.default)('long', date, options);
        }
    }
};
function $6934f899b8aefb37$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $6JaJ1.default)(timeZone, originalDate, true) / $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $6934f899b8aefb37$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $6934f899b8aefb37$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter);
}
function $6934f899b8aefb37$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $6934f899b8aefb37$var$addLeadingZeros(minutes, 2);
}
var $6934f899b8aefb37$export$2e2bcd8739ae039 = $6934f899b8aefb37$var$formatters;

});
parcelRegister("927cR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6939e400b4f30595$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $6939e400b4f30595$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $6939e400b4f30595$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $6939e400b4f30595$var$partsTimeZone(dtf, date) : $6939e400b4f30595$var$hackyTimeZone(dtf, date);
}
function $6939e400b4f30595$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $6939e400b4f30595$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $6939e400b4f30595$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("6JaJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e5f43d4fc19099f$export$2e2bcd8739ae039);

var $gTcao = parcelRequire("gTcao");

var $6Bk9v = parcelRequire("6Bk9v");
var $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR = 3600000;
var $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE = 60000;
var $4e5f43d4fc19099f$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $4e5f43d4fc19099f$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $4e5f43d4fc19099f$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $4e5f43d4fc19099f$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$4e5f43d4fc19099f$var$validateTimezone(hours)) return NaN;
        return -(hours * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $4e5f43d4fc19099f$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$4e5f43d4fc19099f$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR + minutes * $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($4e5f43d4fc19099f$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $4e5f43d4fc19099f$var$toUtcDate(date);
        var offset = $4e5f43d4fc19099f$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $4e5f43d4fc19099f$var$toUtcDate(date) {
    return (0, $6Bk9v.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $4e5f43d4fc19099f$var$calcOffset(date, timezoneString) {
    var tokens = (0, $gTcao.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $6Bk9v.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $4e5f43d4fc19099f$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $4e5f43d4fc19099f$var$validIANATimezoneCache = {};
function $4e5f43d4fc19099f$var$isValidTimezoneIANAString(timeZoneString) {
    if ($4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("gTcao", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4bb38695b1c145f$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $c4bb38695b1c145f$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $c4bb38695b1c145f$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $c4bb38695b1c145f$var$partsOffset(dtf, date) : $c4bb38695b1c145f$var$hackyOffset(dtf, date);
}
var $c4bb38695b1c145f$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $c4bb38695b1c145f$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $c4bb38695b1c145f$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $c4bb38695b1c145f$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $c4bb38695b1c145f$var$dtfCache = {};
function $c4bb38695b1c145f$var$getDateTimeFormat(timeZone) {
    if (!$c4bb38695b1c145f$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $c4bb38695b1c145f$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $c4bb38695b1c145f$var$dtfCache[timeZone];
}

});

parcelRegister("6Bk9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ce5d4976aa71227$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $4ce5d4976aa71227$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("2q3K8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c30e9c4205eee83$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $6JaJ1 = parcelRequire("6JaJ1");

var $jxCgc = parcelRequire("jxCgc");
var $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR = 3600000;
var $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE = 60000;
var $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $1c30e9c4205eee83$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $jxCgc.default)
};
function $1c30e9c4205eee83$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $1c30e9c4205eee83$var$splitDateString(argument);
    var parseYearResult = $1c30e9c4205eee83$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $1c30e9c4205eee83$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $1c30e9c4205eee83$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $6JaJ1.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $1c30e9c4205eee83$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $1c30e9c4205eee83$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $1c30e9c4205eee83$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $1c30e9c4205eee83$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1c30e9c4205eee83$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $1c30e9c4205eee83$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $1c30e9c4205eee83$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $1c30e9c4205eee83$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $1c30e9c4205eee83$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $1c30e9c4205eee83$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $1c30e9c4205eee83$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$1c30e9c4205eee83$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $1c30e9c4205eee83$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $1c30e9c4205eee83$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$1c30e9c4205eee83$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $1c30e9c4205eee83$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$1c30e9c4205eee83$var$validateWeekDate(year, week)) return new Date(NaN);
        return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $1c30e9c4205eee83$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$1c30e9c4205eee83$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $1c30e9c4205eee83$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $1c30e9c4205eee83$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$1c30e9c4205eee83$var$validateTime(hours)) return NaN;
        return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $1c30e9c4205eee83$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$1c30e9c4205eee83$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $1c30e9c4205eee83$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$1c30e9c4205eee83$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $1c30e9c4205eee83$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $1c30e9c4205eee83$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1c30e9c4205eee83$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1c30e9c4205eee83$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
        if (isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $1c30e9c4205eee83$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $1c30e9c4205eee83$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("jxCgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e39ec715b89452b2$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $e39ec715b89452b2$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $e39ec715b89452b2$export$2e2bcd8739ae039 = $e39ec715b89452b2$var$tzPattern;

});



parcelRegister("2b4cP", function(module, exports) {

$parcel$export(module.exports, "default", () => $195fdf0d1f4870c0$export$2e2bcd8739ae039);

var $6JaJ1 = parcelRequire("6JaJ1");

var $2q3K8 = parcelRequire("2q3K8");
function $195fdf0d1f4870c0$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $2q3K8.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $6JaJ1.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("58UyI", function(module, exports) {

$parcel$export(module.exports, "CustomUserProfileClient", () => $2fe94d89052b4b13$export$4b2a86afb64f42f1);

var $dFLsP = parcelRequire("dFLsP");

var $7f4tk = parcelRequire("7f4tk");

var $7I2zi = parcelRequire("7I2zi");
class $2fe94d89052b4b13$export$4b2a86afb64f42f1 extends (0, $dFLsP.default) {
    constructor(fabricPfDirUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        }), this.makeRequest = async (cloudId, userId)=>{
            // call old profile rest endpoint
            try {
                if ((0, $7I2zi.isCustomerAccount)(userId)) {
                    const response = await (0, $7f4tk.default)(`/rest/api/3/user?accountId=${userId}`);
                    return (0, $7I2zi.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});
parcelRegister("7I2zi", function(module, exports) {

$parcel$export(module.exports, "generateUserLink", () => $9d3ef40360103f2e$export$f4673d7e11341514);
$parcel$export(module.exports, "generateTeamLink", () => $9d3ef40360103f2e$export$b163ce931504dcff);
$parcel$export(module.exports, "isTeamProfileCardEventContentRendered", () => $9d3ef40360103f2e$export$6dc006c3779708c0);
$parcel$export(module.exports, "fireLegacyTeamAnalytics", () => $9d3ef40360103f2e$export$ffbbcf55d672ec61);
$parcel$export(module.exports, "restResponseToUserData", () => $9d3ef40360103f2e$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $9d3ef40360103f2e$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $9d3ef40360103f2e$export$518f47d656cb4e1a);

var $8zOmE = parcelRequire("8zOmE");

var $8vYX2 = parcelRequire("8vYX2");

const $9d3ef40360103f2e$export$f4673d7e11341514 = (userId)=>`/jira/people/${userId}`;
const $9d3ef40360103f2e$export$b163ce931504dcff = (teamId)=>`/jira/people/team/${teamId}`;
const $9d3ef40360103f2e$export$7b55c373f7e07896 = (label, profileUrl)=>({
        id: 'view-profile',
        label: label,
        callback: (event)=>{
            event.stopPropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(profileUrl);
        }
    });
const $9d3ef40360103f2e$export$6dc006c3779708c0 = (analyticsPayload)=>analyticsPayload?.action === 'rendered' && analyticsPayload?.actionSubjectId === 'content';
const $9d3ef40360103f2e$export$ffbbcf55d672ec61 = (analyticsEvent)=>{
    if (analyticsEvent?.payload?.eventType === 'ui') {
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `legacyTeamProfileCard ${analyticsEvent.payload.action}}`);
        if ($9d3ef40360103f2e$export$6dc006c3779708c0(analyticsEvent?.payload)) (0, $8zOmE.fireScreenAnalytics)(analyticsEvent);
    }
};
const $9d3ef40360103f2e$export$66691b1affeb3bc5 = (userData)=>({
        avatarUrl: userData.avatarUrls?.['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $9d3ef40360103f2e$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $9d3ef40360103f2e$var$getSpaViewProfileAction = (intl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
const $9d3ef40360103f2e$var$getAssignedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $9d3ef40360103f2e$var$getReportedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $9d3ef40360103f2e$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $9d3ef40360103f2e$export$518f47d656cb4e1a = (accountId, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $e6a2e0952e4731b8$export$23cedd3261bd8015:
                return $9d3ef40360103f2e$var$getSpaViewProfileAction(intl, accountId, onPushAction, onActionCleanup);
            case 0, $e6a2e0952e4731b8$export$6bef782d14a92db8:
                return $9d3ef40360103f2e$var$getAssignedIssuesAction(intl, accountId);
            case 0, $e6a2e0952e4731b8$export$6b36f20db7a18a86:
                return $9d3ef40360103f2e$var$getReportedIssuesAction(intl, accountId);
            case 0, $e6a2e0952e4731b8$export$56da0dd0b0aa67b9:
                return $9d3ef40360103f2e$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $9d3ef40360103f2e$var$getSpaViewProfileAction(intl, accountId, onPushAction, onActionCleanup)
    ];
};

});
parcelRegister("8vYX2", function(module, exports) {

$parcel$export(module.exports, "profileCardMessages", () => $a3966562156ba1e4$export$49f2d2ccb123fddf);

var $7VHMR = parcelRequire("7VHMR");
const $a3966562156ba1e4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $a3966562156ba1e4$export$49f2d2ccb123fddf = (0, $7VHMR.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    }
});

});





parcelRegister("3Mgim", function(module, exports) {

$parcel$export(module.exports, "ProfileCardView", () => $88950f4d1a3b3888$export$da5098f02f405a40);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $37PA3 = parcelRequire("37PA3");

var $d4xRU = parcelRequire("d4xRU");
var $7HGHK = parcelRequire("7HGHK");

var $2OMDV = parcelRequire("2OMDV");

var $dCm1o = parcelRequire("dCm1o");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $9l5Jv = parcelRequire("9l5Jv");

const $88950f4d1a3b3888$var$PEOPLE_PROFILE_PATH = '/people/';
const $88950f4d1a3b3888$var$ProfileCardTriggerWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)((0, $aa25c26fa0ed8a05$export$a1455360a24a2234), {
    analytics: ''
})((0, $37PA3.default));
const $88950f4d1a3b3888$export$da5098f02f405a40 = ({ children: children, position: position = 'top-start', trigger: trigger = 'hover', accountId: accountId, actions: actions, onProfileClick: onProfileClick, addFlag: addFlag, dismissFlag: dismissFlag, testId: testId, prepopulatedData: prepopulatedData, ariaHideProfileTrigger: ariaHideProfileTrigger, isChildComment: isChildComment, shouldTruncate: shouldTruncate })=>{
    const profileCardWrapperRef = (0, $5uXOq.useRef)(null);
    const cloudId = (0, $koeKL.useCloudId)();
    const viewingUserId = (0, $90yGq.useAccountId)();
    const { profileClient: profileClient } = (0, $9l5Jv.useProfileClient)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88950f4d1a3b3888$var$Wrapper, {
        ref: profileCardWrapperRef,
        onClick: (event)=>{
            if (profileCardWrapperRef?.current !== null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            !profileCardWrapperRef?.current?.contains(event.target)) event.stopPropagation();
        },
        "data-vc": `profilecard-wrapper${false ? '-ssr' : ''}`,
        isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)(),
        className: (0, $bwpsq.default)([
            isChildComment && "_kqswh2mm _1hjgt94y _1pty1eak _161e1v33 _ft5qdlk8 _2wzdc71f _2kncueha _qlwiueha _aetrb3bt _631ousvi _18postnw _g0nf1yie _15l21pz7 _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            isChildComment && "_p12f1kdh _kqswh2mm _uglpt94y _161e1v33 _1pty1eak _2knc163p _qlwi163p _631ousvi _aetrb3bt _18postnw _g0nf1yie _15l24uri _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            shouldTruncate && "_1reo15vq _18m915vq _1o9zidpf _1bto1l2s _o5721q9c"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88950f4d1a3b3888$var$ProfileCardTriggerWithAnalytics, {
        cloudId: cloudId,
        userId: accountId,
        resourceClient: profileClient,
        position: position,
        trigger: trigger,
        testId: testId,
        actions: actions,
        reportingLinesProfileUrl: $88950f4d1a3b3888$var$PEOPLE_PROFILE_PATH,
        prepopulatedData: prepopulatedData,
        onReportingLinesClick: // @ts-expect-error - TS7006 - Parameter 'user' implicitly has an 'any' type.
        onProfileClick ? (user)=>onProfileClick(user.accountIdentifier) : null,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addFlag: (flag)=>{
            const flagId = (0, $7HGHK.toFlagId)(flag.id);
            addFlag({
                id: flagId,
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        ...props
                    })
            });
        },
        viewingUserId: viewingUserId,
        ariaHideProfileTrigger: ariaHideProfileTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "profilecard-next.ui.profilecard.profilecard-trigger",
        className: (0, $bwpsq.default)([
            shouldTruncate && "_1e0c1nu9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88950f4d1a3b3888$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq",
            __cmplp.isVisualRefresh && "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $88950f4d1a3b3888$var$profileCardStyles = null;
const $88950f4d1a3b3888$var$replyProfileCardStyles = null;
const $88950f4d1a3b3888$var$truncatedProfileCardStyles = null;
const $88950f4d1a3b3888$var$truncatedProfileCardInnerStyles = null;
$88950f4d1a3b3888$var$Wrapper.displayName = 'Wrapper';

});
parcelRegister("37PA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f0fdc37b33e30ae$export$2e2bcd8739ae039);


var $dYuIx = parcelRequire("dYuIx");

var $264zF = parcelRequire("264zF");
var $1f0fdc37b33e30ae$export$2e2bcd8739ae039 = (0, $264zF.default);

});
parcelRegister("dYuIx", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $78b4a66e55984f2d$export$403d297463f226af);

var $5uXOq = parcelRequire("5uXOq");

const $78b4a66e55984f2d$export$403d297463f226af = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("9jxN3")));

});
parcelRegister("9jxN3", function(module, exports) {

let $6c80196f700d9a25$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6c80196f700d9a25$var$load("h2MrD"),
    $6c80196f700d9a25$var$load("bYT2S"),
    $6c80196f700d9a25$var$load("l3dV9")
]).then(()=>parcelRequire('lrMir'));

});


parcelRegister("264zF", function(module, exports) {

$parcel$export(module.exports, "default", () => $74b3c02273951832$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $adIkV = parcelRequire("adIkV");
var $gH4E9 = parcelRequire("gH4E9");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k5uoT = parcelRequire("k5uoT");

var $4sfdL = parcelRequire("4sfdL");

var $chprS = parcelRequire("chprS");

var $jnj6z = parcelRequire("jnj6z");

var $ivXTE = parcelRequire("ivXTE");


var $kDbj5 = parcelRequire("kDbj5");

var $dYuIx = parcelRequire("dYuIx");

var $ifxzB = parcelRequire("ifxzB");
function $74b3c02273951832$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDbj5.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dYuIx.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $74b3c02273951832$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isMounted = (0, $5uXOq.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $VSDnB.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $e41878b3b8cab0db$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $VSDnB.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $e41878b3b8cab0db$export$89a9f35a94d7f196);
    const showTimer = (0, $5uXOq.useRef)(0);
    const hideTimer = (0, $5uXOq.useRef)(0);
    const [visible, setVisible] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
    const [hasError, setHasError] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $5uXOq.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $5uXOq.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $5uXOq.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $5uXOq.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const triggerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $5uXOq.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $5uXOq.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $5uXOq.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $5uXOq.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $VSDnB.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $5uXOq.useCallback)(()=>{
        return (0, $4sfdL.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)($74b3c02273951832$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $2OMIu.jsx)($74b3c02273951832$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $chprS.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        children: children
                    });
                },
                zIndex: (0, $k5uoT.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $VSDnB.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adIkV.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $gH4E9.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $74b3c02273951832$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnj6z.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ifxzB.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("adIkV", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $c3877992df568d20$export$93fe397a02fe8b76);

var $5uXOq = parcelRequire("5uXOq");

const $c3877992df568d20$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("7rsnG")));

});
parcelRegister("7rsnG", function(module, exports) {

let $56b111e3894d3389$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $56b111e3894d3389$var$load("cM9em"),
    $56b111e3894d3389$var$load("fr9NE"),
    $56b111e3894d3389$var$load("h2MrD"),
    $56b111e3894d3389$var$load("bYT2S"),
    $56b111e3894d3389$var$load("HRhLG")
]).then(()=>parcelRequire('iRLc5'));

});


parcelRegister("gH4E9", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $b9e3bff5640b4187$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $b9e3bff5640b4187$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $b9e3bff5640b4187$export$7a1fc1a1b0477464);
var $b9e3bff5640b4187$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    return KudosType;
}({});
var $b9e3bff5640b4187$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $b9e3bff5640b4187$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($b9e3bff5640b4187$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("4sfdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1251cd76451c32$export$2e2bcd8739ae039);
const $ea1251cd76451c32$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $ea1251cd76451c32$export$2e2bcd8739ae039 = $ea1251cd76451c32$var$filterActions;

});

parcelRegister("chprS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b051cf4c3ebf799$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4b051cf4c3ebf799$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($4b051cf4c3ebf799$var$messages.label, {
        fullName: fullName
    }) : formatMessage($4b051cf4c3ebf799$var$messages.fallbackLabel);
};
const $4b051cf4c3ebf799$var$messages = (0, $7VHMR.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $4b051cf4c3ebf799$export$2e2bcd8739ae039 = $4b051cf4c3ebf799$var$getLabelMessage;

});

parcelRegister("jnj6z", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $a03faa2abdc74ae6$export$6aa22a823032b784);
$parcel$export(module.exports, "ProfileImage", () => $a03faa2abdc74ae6$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $a03faa2abdc74ae6$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $a03faa2abdc74ae6$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $a03faa2abdc74ae6$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $a03faa2abdc74ae6$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $a03faa2abdc74ae6$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $a03faa2abdc74ae6$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $a03faa2abdc74ae6$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $a03faa2abdc74ae6$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $a03faa2abdc74ae6$export$2062e7265a95a823);
$parcel$export(module.exports, "LozengeWrapper", () => $a03faa2abdc74ae6$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $a03faa2abdc74ae6$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $a03faa2abdc74ae6$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $a03faa2abdc74ae6$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "SpinnerContainer", () => $a03faa2abdc74ae6$export$a5e06607a5ac6158);
$parcel$export(module.exports, "CardContainer", () => $a03faa2abdc74ae6$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $a03faa2abdc74ae6$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $a03faa2abdc74ae6$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $a03faa2abdc74ae6$export$b0ec2c767a0e0eab);
/* Card.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");


var $k5uoT = parcelRequire("k5uoT");

var $huHkE = parcelRequire("huHkE");

var $bWGt6 = parcelRequire("bWGt6");
function $a03faa2abdc74ae6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a03faa2abdc74ae6$var$kudosButtonAnimationTransformationCompiled = null;
const $a03faa2abdc74ae6$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    profileImage: "_kqswstnw _154i1ejb _1ltv1ejb",
    actionsFlexSpacer: "_16jlkb7n _1o9zidpf _i0dl1wug",
    kudosBlobAnimationStyle: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _154ixy5q",
    animationWrapper: "_mkrz1rip _kqswstnw _154ize3t _1ltvze3t _94n5ze3t _1xi2ze3t",
    animatedKudosButton: "_18u0u2gc",
    actionButtonGroup: "_zulp12x7 _uiztglyw _19pkpxbi _2hwxze3t _18u0ze3t _otyrze3t _y3gnusic _1bahesu3 _1e0c1txw",
    overflowActionButtonsWrapper: "_1e0c1o8l _1bsbzwfg _4t3izwfg",
    cardContent: "_1e0c1txw _2lx21bp4 _1tkebv7e",
    detailsGroup: "_1e0c1txw _2lx21bp4 _18u01epz _19bvxy5q _1bsb18pt",
    disabledInfo: "_11c81o8v _syaz1fxt _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t",
    lozengeWrapper: "_19pkpxbi _1e0c1ule",
    customLozengeContainer: "_1e0c1txw _2lx2vrvc _1n261g80 _1bah1y6m _19pkutpp",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm",
    cardContainer: "_1reo15vq _18m915vq _kqswh2mm _12vemgnk _1lrw14bs _ca0q1ejb _19bv1ejb _u5f31ejb _n3td1ejb",
    cardContainerActiveUser: "_1itk1419",
    cardContainerDisabledUser: "_1itkkf3t",
    cardContainerWithElevation: "_2rkoglpi _16qs1cd0",
    detailsLabel: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1y6m _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t _o5721q9c",
    detailsLabelExtraTopSpace: "_19pkxy5q",
    detailsLabelIcon: "_1e0c1txw _1o9zidpf _syaz131l _1bsb7vkz _4t3i7vkz _s7n4jp4b _19pkze3t",
    detailsLabelText: "_1reo15vq _18m915vq _11c8dcr7 _1bto1l2s _syaz1fxt _19pkze3t _18u0ze3t",
    kudosBlobAnimation: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _j7hq1q51 _tip8kb7n _5sagi11n _1itkiwwe",
    jobTitleLabel: "_19pkze3t _otyrze3t _18u0utpp _2hwxze3t",
    appTitleLabel: "_2rkoglpi _syaz1fxt _u5f312x7 _19bv12x7 _1bsb1ns9 _19pk1b66 _otyrze3t _18u0utpp _2hwxze3t"
};
const $a03faa2abdc74ae6$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CardWrapperLegacy, {
        "data-testid": testId,
        role: role,
        "aria-labelledby": labelledBy,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CardWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo19"
})("background-color:", (0, $huHkE.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:360px;");
const $a03faa2abdc74ae6$export$a7a74ab5cffd1455 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.profileImage),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$ProfileImageLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$ProfileImageLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo18"
})({
    name: "eukccz",
    styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
});
const $a03faa2abdc74ae6$export$d395c8d16f1e359d = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.actionsFlexSpacer)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$ActionsFlexSpacerLegacy, {}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$ActionsFlexSpacerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo17"
})({
    name: "18pny36",
    styles: "flex:1 0 auto"
}); // eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
const $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation = (0, $f8Sb3.keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
const $a03faa2abdc74ae6$export$b08abf2f97b92ea5 = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.kudosBlobAnimationStyle)
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$KudosBlobAnimationStyleLegacy, {
        className: "kudos-blob-animation"
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a03faa2abdc74ae6$var$KudosBlobAnimationStyleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo16"
})("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", 32 / 14, "em;animation-name:", $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
const $a03faa2abdc74ae6$export$4a8a956251d4bf6f = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.kudosBlobAnimationStyle)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$KudosBlobAnimationLegacy, {});
const $a03faa2abdc74ae6$var$KudosBlobAnimationLegacy = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$export$b08abf2f97b92ea5, {});
const $a03faa2abdc74ae6$export$58517bb1b373a54c = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.animationWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$AnimationWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$AnimationWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo15"
})("clip-path:inset(0px 0px 0px 0px round ", (0, $k5uoT.borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
const $a03faa2abdc74ae6$export$6196a3f52a6944fe = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.animatedKudosButton),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$AnimatedKudosButtonLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$AnimatedKudosButtonLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo14"
})({
    name: "18xp5qc",
    styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
});
const $a03faa2abdc74ae6$export$73d695ae27330056 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.actionButtonGroup),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$ActionButtonGroupLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$ActionButtonGroupLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo13"
})("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $a03faa2abdc74ae6$export$ff778e5b796745a6 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.overflowActionButtonsWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$OverflowActionButtonsWrapperLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$OverflowActionButtonsWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo12"
})("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $a03faa2abdc74ae6$export$64ef9b8c11710c47 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.cardContent),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CardContentLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CardContentLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo11"
})({
    name: "1jc6z0y",
    styles: "display:flex;flex-direction:column;min-height:136px"
});
const $a03faa2abdc74ae6$export$35cf684daac137ac = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsGroup),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsGroupLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsGroupLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo10"
})({
    name: "c8pdei",
    styles: "display:flex;flex-direction:column;margin-left:116px;width:196px"
});
const $a03faa2abdc74ae6$export$2062e7265a95a823 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.disabledInfo),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DisabledInfoLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DisabledInfoLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo9"
})("font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $huHkE.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
const $a03faa2abdc74ae6$export$75180efdd3f4d9c2 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.lozengeWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$LozengeWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$LozengeWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo8"
})({
    name: "m760b1",
    styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
});
const $a03faa2abdc74ae6$export$6ebf103500ba5a45 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.customLozengeContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CustomLozengeContainerLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CustomLozengeContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)($a03faa2abdc74ae6$export$75180efdd3f4d9c2, {
    target: "e1ebb2vo7"
})({
    name: "15oqcei",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
});
const $a03faa2abdc74ae6$export$d6c0e5f211c8d617 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.jobTitleLabel),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            maxLines: 1,
            color: "color.text.inverse",
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$JobTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$JobTitleLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1ebb2vo6"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $huHkE.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;");
const $a03faa2abdc74ae6$export$4865ffa72a4d5f9 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.appTitleLabel),
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            color: "color.text",
            size: "UNSAFE_small",
            weight: "bold",
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$AppTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$AppTitleLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1ebb2vo5"
})("background:", (0, $huHkE.appLabelBgColor), ";color:", (0, $huHkE.appLabelTextColor), ";border-radius:", (0, $k5uoT.borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:var(--ds-font-weight-bold, 700);text-transform:uppercase;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;");
const $a03faa2abdc74ae6$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.spinnerContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$SpinnerContainerLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$SpinnerContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo4"
})({
    name: "1e8m6rx",
    styles: "align-items:center;display:flex;height:96px;justify-content:center;position:relative"
});
const $a03faa2abdc74ae6$export$8a23e74e5cf3ca41 = ({ children: children, isDisabledUser: isDisabledUser, withoutElevation: withoutElevation })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.cardContainer, isDisabledUser ? $a03faa2abdc74ae6$var$styles.cardContainerDisabledUser : $a03faa2abdc74ae6$var$styles.cardContainerActiveUser, !withoutElevation && $a03faa2abdc74ae6$var$styles.cardContainerWithElevation),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CardContainerLegacy, {
        isDisabledUser: isDisabledUser,
        withoutElevation: withoutElevation,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CardContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo3"
})("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% 96px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $829f609a65d26a98$export$7d3359664e8bb0e5}, 0 0 1px ${0, $829f609a65d26a98$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, $k5uoT.borderRadius)()}px`, ";overflow:hidden;");
const $a03faa2abdc74ae6$export$138a08882ebf7289 = ({ children: children, extraTopSpace: extraTopSpace = false })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsLabel, extraTopSpace && $a03faa2abdc74ae6$var$styles.detailsLabelExtraTopSpace),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo2"
})({
    name: "vjwven",
    styles: "display:flex;align-items:center;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}"
});
const $a03faa2abdc74ae6$export$79d7d9b2f6a70c70 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "dt",
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsLabelIcon),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsLabelIconLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsLabelIconLegacy = /*#__PURE__*/ (0, $bWGt6.default)("dt", {
    target: "e1ebb2vo1"
})("display:flex;flex-shrink:0;color:", (0, $huHkE.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
const $a03faa2abdc74ae6$export$b0ec2c767a0e0eab = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "dd",
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsLabelText),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsLabelTextLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsLabelTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("dd", {
    target: "e1ebb2vo0"
})("overflow:hidden;text-overflow:ellipsis;color:", (0, $huHkE.labelTextColor), ";font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-050, 4px);padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("huHkE", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $61d9a2704bf54ca1$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $61d9a2704bf54ca1$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $61d9a2704bf54ca1$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $61d9a2704bf54ca1$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $61d9a2704bf54ca1$export$5c2df128da90e8de);
$parcel$export(module.exports, "appLabelBgColor", () => $61d9a2704bf54ca1$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $61d9a2704bf54ca1$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $61d9a2704bf54ca1$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $61d9a2704bf54ca1$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $61d9a2704bf54ca1$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $61d9a2704bf54ca1$export$be3c814f7ed506ed);

const $61d9a2704bf54ca1$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $61d9a2704bf54ca1$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`;
const $61d9a2704bf54ca1$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`;
const $61d9a2704bf54ca1$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
const $61d9a2704bf54ca1$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $61d9a2704bf54ca1$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
const $61d9a2704bf54ca1$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
const $61d9a2704bf54ca1$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`;
const $61d9a2704bf54ca1$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
const $61d9a2704bf54ca1$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;

});


const $e41878b3b8cab0db$export$5b956b542f1bc1b3 = 800;
const $e41878b3b8cab0db$export$89a9f35a94d7f196 = 200;

parcelRegister("kDbj5", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $9f87d208f89c63eb$export$4b013ffffcb40af8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $ivXTE = parcelRequire("ivXTE");

var $dG58U = parcelRequire("dG58U");

var $cI0Td = parcelRequire("cI0Td");

var $a3FJs = parcelRequire("a3FJs");

var $iwWWV = parcelRequire("iwWWV");
const $9f87d208f89c63eb$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dG58U.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $5uXOq.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a3FJs.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cI0Td.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwWWV.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("dG58U", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $dd4eeae2be471029$export$3761e66a04602cbd);
const $dd4eeae2be471029$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $dd4eeae2be471029$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($dd4eeae2be471029$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("cI0Td", function(module, exports) {

$parcel$export(module.exports, "default", () => $f71e8c5b4eb5da96$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $hI6SY = parcelRequire("hI6SY");

var $d5Zn3 = parcelRequire("d5Zn3");

var $VSDnB = parcelRequire("VSDnB");

var $cgL5K = parcelRequire("cgL5K");

var $2uTKk = parcelRequire("2uTKk");

var $ivXTE = parcelRequire("ivXTE");
const $f71e8c5b4eb5da96$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2uTKk.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2uTKk.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2uTKk.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hI6SY))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d5Zn3))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && ((0, $VSDnB.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                onClick: reload,
                children: "Try again"
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                appearance: "link",
                onClick: reload,
                children: "Try again"
            }))
        ]
    });
};
var $f71e8c5b4eb5da96$export$2e2bcd8739ae039 = $f71e8c5b4eb5da96$var$ErrorMessage;

});
parcelRegister("2uTKk", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $0619b202cbb0de2c$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $0619b202cbb0de2c$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $0619b202cbb0de2c$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $huHkE = parcelRequire("huHkE");

var $bWGt6 = parcelRequire("bWGt6");
const $0619b202cbb0de2c$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $0619b202cbb0de2c$export$bb27b7e39840238f = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.errorWrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$ErrorWrapperLegacy, {
        "data-testId": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$ErrorWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1gaqn292"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $huHkE.errorIconColor)
});
const $0619b202cbb0de2c$export$b065fd053267ec81 = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.errorTitle),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$ErrorTitleLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$ErrorTitleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn291"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $huHkE.errorTitleColor),
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $0619b202cbb0de2c$export$90d92ccfb27352c6 = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.teamErrorText),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$TeamErrorTextLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$TeamErrorTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn290"
})({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});


parcelRegister("a3FJs", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $642b3278878bc39a$export$2c6604b50c274e6f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $642b3278878bc39a$var$styles = (0, $8CUq3.xcss)({
    width: '360px'
});
const $642b3278878bc39a$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $642b3278878bc39a$var$styles,
        children: children
    });
};

});

parcelRegister("iwWWV", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $b487397875f853f0$export$ed0ca9c1d49ea0bf);

var $5uXOq = parcelRequire("5uXOq");

const $b487397875f853f0$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2K454")));

});
parcelRegister("2K454", function(module, exports) {

let $1ff30b051f5792f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1ff30b051f5792f2$var$load("cM9em"),
    $1ff30b051f5792f2$var$load("fr9NE"),
    $1ff30b051f5792f2$var$load("h2MrD"),
    $1ff30b051f5792f2$var$load("bYT2S"),
    $1ff30b051f5792f2$var$load("cLGTI")
]).then(()=>parcelRequire('9gV7o'));

});



parcelRegister("ifxzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $44786ae639641a68$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $jnj6z = parcelRequire("jnj6z");

var $ivXTE = parcelRequire("ivXTE");
const $44786ae639641a68$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnj6z.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
    });
};
var $44786ae639641a68$export$2e2bcd8739ae039 = $44786ae639641a68$var$UserLoadingState;

});



const $aa25c26fa0ed8a05$export$a1455360a24a2234 = 'profileCardNextView';




//# sourceMappingURL=async-profile-card-next.5bf8ec33.js.map
